import api from "./api";

export class CareerApiService {
    public file = null;
    public jobTitle = null;
    public jobId = null;
    public job_name = null;

    static UploadCv(user_id:any,formdata:any,title:any){
        return api.post(`upload/${user_id}?job_title=${title}`,formdata,{
            headers:{
                'Content-Type': 'multipart/form-data',
            }
        })
    }

    static OccupSearch(occup:any){
        return api.get(`api/job_titles?query=${occup}&lang=en`)
    }

    static SkillSearch(skill:any){
        return api.get(`api/skills_list?query=${skill}&lang=en`)
    }

    static MissingSkills(occupation_id:any,cv_id:any,location:string='Global',includeInterns=false){
        return api.get('api/missing_skills', {
            params: { occupation_id, cvid: cv_id, location, include_interns: includeInterns ? 1 : undefined } })
    }

    static DesiredJob(occupation_id:any,user_id:any,job:any){
        return api.post('desired_job',
            {"userid":user_id,"desired_job": job,"occup_id": occupation_id})
    }

    static getJobId(user_id:any){
        return api.get(`desired_job/${user_id}`)
    }

    static getSkillsForJob(occupation_id:any,location:string='Global'){
        return api.get('api/skills', { params: { occupation_id, location } })
    }

    static ImportantSkills(occupation_id:any){
        return api.get(`api/important_skills?occupation_id=${occupation_id}`)
    }

    static HiddenSkills(occupation_id:any){
        return api.get(`api/hidden_skills?occupation_id=${occupation_id}`)
    }

    static TransitionLegends(occupation_id:any){
        return api.get(`api/transition_legends?occupation_id=${occupation_id}`)
    }

    static AltLabels(occupation_id:any){
        return api.get(`api/job_alt_labels?occupation_id=${occupation_id}`)
    }

    static PlatformStats(){
        return api.get(`platform-stats`)
    }
}